<template>
    <AbstractTheme color="#99142a" :name="this.$options.name" :misc="misc" :show="show"/>
</template>

<script>
import AbstractTheme from './AbstractTheme'

export default {
  name: 'Red',
  props: {
    misc: Object,
    show: Boolean,
  },
  components: { AbstractTheme },
}
</script>

<style lang="scss">
    //$color-primary: #99142a !default;
    //@import '../../scss/helpers/variables';
    //@import '../../scss/explorer';
</style>



// WEBPACK FOOTER //
// src/components/theme/Red.vue